import { useTranslation } from "react-i18next"

const StatCard = ({ label, value }) => (
  <div className="bg-white rounded-2xl border border-[#E7EAEF] px-4 py-3">
    <div className="text-lg font-semibold text-[#1F2937]">{value ?? "—"}</div>
    <div className="text-xs text-[#9AA5B4] mt-0.5">{label}</div>
  </div>
)

const OverviewStats = ({ overview }) => {
  const { t } = useTranslation()
  if (!overview) return null

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
      <StatCard label={t("admin_saved_tours.overview.companies")} value={overview.companies_count} />
      <StatCard label={t("admin_saved_tours.overview.users")} value={overview.users_count} />
      <StatCard label={t("admin_saved_tours.overview.sessions")} value={overview.sessions_count} />
      <StatCard label={t("admin_saved_tours.overview.tours")} value={overview.tours_count} />
    </div>
  )
}

export default OverviewStats
